module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesis-video-signaling-2019-12-04.paginators.json
// module id = 708
// module chunks = 1